const initialState={
    propietarios:[],
    edificio:[]
}

const rootReducer=(state=initialState,action)=>{
    switch(action.type){
        case 'GET_PROP':
            return{
                ...state,
                propietarios:action.payload
            }
        case 'GET_ED_ID':
            return{
                ...state,
                edificio:action.payload
            }
        default:
            return state
    }
}
export default rootReducer